/**
 * Valor monetário no padrão brasileiro (ex.: R$ 1.000.000,50).
 */
export function formatBrl(value) {
  const n = Number(value);
  const safe = Number.isFinite(n) ? n : 0;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(safe);
}
